import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

import {Order} from "@Redux/slices/trade/trades/types"
import {asyncLogout} from "@Redux/slices/user/UserSlice"

export const setOrders = createAsyncThunk<{orders: Order[], accountId: string}, {orders: Order[], accountId: string}>('user/setUserOrders', async (payload) => {
  return payload
})

interface OrdersStateInterface {
  isLoading: boolean
  orderToEdit: Order | null
  error: null | string
  ordersList: { [accountId: string]: Order[] }
}

const initialState: OrdersStateInterface = {
  ordersList: {},
  orderToEdit: null,
  isLoading: false,
  error: null,
}

export const OrdersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setEditOrder: (state, action: PayloadAction<Order>) => {
      state.orderToEdit = action.payload
    },
    clearEditOrder: (state) => {
      state.orderToEdit = null
    },
  },
  extraReducers: (builder) => {
    builder
      // .addCase(fetchOrders.pending, (state) => {
      //   state.isLoading = true
      //   state.error = null
      // })
      .addCase(setOrders.fulfilled, (state, { payload }) => {
        if (payload.accountId) {
          state.ordersList[payload.accountId] = payload.orders
          state.orderToEdit = payload.orders?.find(order => order.id == state.orderToEdit?.id) ?? null
        }
        state.isLoading = false
      })
      .addCase(asyncLogout.fulfilled, (state) => {
        state.ordersList = {}
      })
  },
})

export const { setEditOrder, clearEditOrder } = OrdersSlice.actions
export default OrdersSlice.reducer
